import {ElementRef, Injectable} from "@angular/core";
import {MaterializePlateFootCommonData, MaterializePlateFrame} from "../agent/materializeAgentPlate";

@Injectable({
    providedIn: 'root'
})
export class MaterializePlateExamControl {

    // private static readonly  cellHeight = 10;
    // private static readonly cellWidth = 15;

    clearCanvas(canvas: ElementRef<HTMLCanvasElement>) {
        const context = canvas.nativeElement.getContext('2d');
        if (context) {
            context.clearRect(0, 0, canvas.nativeElement.width, canvas.nativeElement.height);
        }
    }drawPressureData(
        canvas: ElementRef<HTMLCanvasElement>,
        frame: number[][],
        canvasCellWidth: number,
        canvasCellHeight: number,
        allPrecision: boolean,
        clearCanvas: boolean,
        scale = 1
    )

     {
        if (clearCanvas) {
            this.clearCanvas(canvas);
        }

        const context = canvas.nativeElement.getContext('2d');
        if (!context) return;

        const maxValue = Math.max(...frame.flat());

        const totalHeight = frame.length;
        const totalWidth = frame[0].length;

        const height = canvasCellHeight * scale;
        const width = canvasCellWidth * scale;

        canvas.nativeElement.height = (totalHeight + 1) * height;
        canvas.nativeElement.width = (totalWidth + 1) * width;

        const subDivH = height;
        const subDivW = width;

        // Calcul des tailles réelles de sous-pixels
        const subPixelWidth = width / subDivW;
        const subPixelHeight = height / subDivH;

        for (let row = 0; row < totalHeight; row++) {
            for (let col = 0; col < totalWidth; col++) {
                const TL = frame[row][col];
                if (TL > 0 || allPrecision) {
                    const TR = (col + 1 < totalWidth) ? frame[row][col + 1] : TL;
                    const BL = (row + 1 < totalHeight) ? frame[row + 1][col] : TL;
                    const BR = (row + 1 < totalHeight && col + 1 < totalWidth) ? frame[row + 1][col + 1] : TL;

                    for (let subRow = 0; subRow < subDivH; subRow++) {
                        for (let subCol = 0; subCol < subDivW; subCol++) {
                            const u = subCol / (subDivW - 1);
                            const v = subRow / (subDivH - 1);

                            const interpolatedValue =
                                TL * (1 - u) * (1 - v) +
                                TR * u * (1 - v) +
                                BL * (1 - u) * v +
                                BR * u * v;

                            const x = col * width + subCol * subPixelWidth;
                            const y = row * height + subRow * subPixelHeight;

                            context.fillStyle = this.getColorFromValue(interpolatedValue, maxValue);
                            context.fillRect(x, y, subPixelWidth, subPixelHeight);
                        }
                    }
                }
            }
        }
    }

    drawCenterOfGravities(canvas: HTMLCanvasElement,
                          centerOfGravities: PressureGravityCenter[],
                          frame: number[][],
                          canvasCellWidth: number,
                          canvasCellHeight: number,
                          thickness = 6,
                          scale = 1) {
        const ctx = canvas.getContext('2d');

        if (!ctx || centerOfGravities.length === 0) return;

        const height = canvasCellHeight * scale;
        const width = canvasCellWidth * scale;

        // First draw points
        centerOfGravities.forEach((gravityCenter) => {
            const centerX = gravityCenter.x * width;
            const centerY = gravityCenter.y * height;
            ctx.beginPath();
            ctx.arc(centerX, centerY, thickness / 2, 0, Math.PI * 2); // cercle complet
            ctx.fillStyle = 'gray';
            ctx.fill();
        });

        // Lines between points
        ctx.strokeStyle = 'gray';
        ctx.lineWidth = scale;
        ctx.beginPath();

        const first = centerOfGravities[0];
        ctx.moveTo(
            first.x * width,
            first.y * height
        );

        for (let i = 1; i < centerOfGravities.length; i++) {
            const gravityCenter = centerOfGravities[i];
            const centerX = gravityCenter.x * width;
            const centerY = gravityCenter.y * height;
            ctx.lineTo(centerX, centerY);
        }

        ctx.stroke();
    }


    drawGravityCenterAsCross(canvas: ElementRef<HTMLCanvasElement>,
                             gravityCenter: PressureGravityCenter,
                             canvasCellWidth: number,
                             canvasCellHeight: number,
                             scale = 1) {

        const height = canvasCellHeight * scale;
        const width = canvasCellWidth* scale;

        const centerX = gravityCenter.x * width;
        const centerY = gravityCenter.y * height;
        const ctx = canvas.nativeElement.getContext('2d');
        // Style de la croix
        ctx.strokeStyle = 'red';
        ctx.lineWidth =  scale;

        // Ligne horizontale de la croix
        ctx.beginPath();
        ctx.moveTo(0, centerY);
        ctx.lineTo(canvas.nativeElement.width, centerY);
        ctx.stroke();

        // Ligne verticale de la croix
        ctx.beginPath();
        ctx.moveTo(centerX, 0);
        ctx.lineTo(centerX, canvas.nativeElement.height);
        ctx.stroke();
    }

    computePressureLocation(
        allFragmentsPressureData: number[][]
    ): PressureLocation {
        const rows = allFragmentsPressureData.length;
        const cols = rows > 0 ? allFragmentsPressureData[0].length : 0;

        // Calcul du centre du tableau
        const xCenter = (cols - 1) / 2;
        const yCenter = (rows - 1) / 2;

        let sumHG = 0;
        let sumHD = 0;
        let sumBG = 0;
        let sumBD = 0;
        let totalSum = 0;

        const xFloor = Math.floor(xCenter);
        const yFloor = Math.floor(yCenter);

        const xDec = xCenter - xFloor; // partie décimale en X
        const yDec = yCenter - yFloor; // partie décimale en Y

        for (let i = 0; i < rows; i++) {
            for (let j = 0; j < cols; j++) {
                const pressure = allFragmentsPressureData[i][j];
                if (pressure === 0) continue;

                totalSum += pressure;

                // Déterminer la fraction gauche/droite
                let leftFraction = 0;
                let rightFraction = 0;

                if (j < xFloor) {
                    // Complètement à gauche
                    leftFraction = 1;
                    rightFraction = 0;
                } else if (j > xFloor) {
                    // Complètement à droite
                    leftFraction = 0;
                    rightFraction = 1;
                } else {
                    // j == xFloor
                    // Fraction gauche = xDec, Fraction droite = 1 - xDec
                    leftFraction = xDec;
                    rightFraction = 1 - xDec;
                }

                // Déterminer la fraction haut/bas
                let topFraction = 0;
                let bottomFraction = 0;

                if (i < yFloor) {
                    // Complètement en haut
                    topFraction = 1;
                    bottomFraction = 0;
                } else if (i > yFloor) {
                    // Complètement en bas
                    topFraction = 0;
                    bottomFraction = 1;
                } else {
                    // i == yFloor
                    // Fraction en haut = yDec, Fraction en bas = 1 - yDec
                    topFraction = yDec;
                    bottomFraction = 1 - yDec;
                }

                // Répartition dans les quadrants
                const pressureHG = pressure * topFraction * leftFraction;
                const pressureHD = pressure * topFraction * rightFraction;
                const pressureBG = pressure * bottomFraction * leftFraction;
                const pressureBD = pressure * bottomFraction * rightFraction;

                sumHG += pressureHG;
                sumHD += pressureHD;
                sumBG += pressureBG;
                sumBD += pressureBD;
            }
        }

        if (totalSum === 0) {
            return { topLeft: 0, topRight: 0, bottomLeft: 0, bottomRight: 0, top: 0, bottom: 0 };
        }
        const topLeft = (sumHG / totalSum) * 100;
        const topRight = (sumHD / totalSum) * 100;
        const bottomLeft = (sumBG / totalSum) * 100;
        const bottomRight = (sumBD / totalSum) * 100;
        return {
            topLeft,
            topRight,
            bottomLeft,
            bottomRight,
            top:  topLeft + topRight,
            bottom: bottomLeft + bottomRight
        };
    }

    computeAveragePressureData(data: MaterializePlateFrame[]): number[][] {
        if (data.length === 0) {
            return [];
        }

        const rowCount = data[0].data.length;
        const colCount = data[0].data[0].length;

        // Initialiser le tableau de moyennes avec des zéros
        const averageData: number[][] = Array.from({ length: rowCount }, () => Array(colCount).fill(0));

        // Parcourir chaque élément et additionner les valeurs
        for (const frame of data) {
            for (let i = 0; i < rowCount; i++) {
                for (let j = 0; j < colCount; j++) {
                    averageData[i][j] += frame.data[i][j];
                }
            }
        }

        // Diviser chaque somme par le nombre de données pour obtenir la moyenne
        for (let i = 0; i < rowCount; i++) {
            for (let j = 0; j < colCount; j++) {
                averageData[i][j] /= data.length;
            }
        }

        return averageData;
    }

    trimZeroEdges(data: number[][]): number[][] {
        const numRows = data.length;
        const numCols = data[0]?.length || 0;

        if (numRows === 0 || numCols === 0) return data;

        let startRow = 0;
        let endRow = numRows - 1;
        let startCol = 0;
        let endCol = numCols - 1;

        // Trouver le nombre de lignes à supprimer depuis le haut
        while (startRow < endRow && data[startRow].every(value => value === 0)) {
            startRow++;
        }

        // Trouver le nombre de lignes à supprimer depuis le bas
        while (endRow > startRow && data[endRow].every(value => value === 0)) {
            endRow--;
        }

        // Trouver le nombre de colonnes à supprimer depuis la gauche
        while (startCol < endCol && data.every(row => row[startCol] === 0)) {
            startCol++;
        }

        // Trouver le nombre de colonnes à supprimer depuis la droite
        while (endCol > startCol && data.every(row => row[endCol] === 0)) {
            endCol--;
        }

        // Ajuster pour garder une ligne ou une colonne de 0 si possible
        if (startRow > 0) startRow--;
        if (endRow < numRows - 1) endRow++;
        if (startCol > 0) startCol--;
        if (endCol < numCols - 1) endCol++;

        // Retourner le tableau en retirant les lignes et colonnes trouvées
        return data.slice(startRow, endRow + 1).map(row => row.slice(startCol, endCol + 1));
    }

    computeCenterOfGravity(allFragmentsPressureData: number[][]): PressureGravityCenter {
        let sumPressure = 0;
        let weightedX = 0;
        let weightedY = 0;

        const rows = allFragmentsPressureData.length;
        const cols = rows > 0 ? allFragmentsPressureData[0].length : 0;

        for (let i = 0; i < rows; i++) {
            for (let j = 0; j < cols; j++) {
                const pressure = allFragmentsPressureData[i][j];
                sumPressure += pressure;
                // j correspond à la position X (colonne), i correspond à la position Y (ligne)
                weightedX += j * pressure;
                weightedY += i * pressure;
            }
        }

        if (sumPressure === 0) {
            // Éviter la division par zéro, retourner par exemple {x: 0, y: 0} si aucune pression détectée
            return { x: 0, y: 0 };
        }

        const centerX = weightedX / sumPressure;
        const centerY = weightedY / sumPressure;

        return { x: centerX, y: centerY };
    }

    getColorFromValue(value: number, maxValue: number): string {
        const t = Math.min(Math.max(value / maxValue, 0), 1); // clamp t between 0 and 1

        // Définir les points de contrôle (vous pouvez en ajouter ou en modifier)
        const colorStops = [
            { t: 0, color: [255, 255, 255] },
            { t: 0.01, color: [0, 0, 255] },// Bleu
            { t: 0.03, color: [0, 255, 255] },   // Cyan
            { t: 0.085, color: [0, 255, 0] },      // Vert
            { t: 0.36, color: [255, 255, 0] },   // Jaune
            { t: 1.0, color: [255, 0, 0] }       // Rouge
        ];

        // Trouver les deux points de contrôle entre lesquels t se situe
        let lower = colorStops[0];
        let upper = colorStops[colorStops.length - 1];

        for (let i = 0; i < colorStops.length - 1; i++) {
            if (t >= colorStops[i].t && t <= colorStops[i+1].t) {
                lower = colorStops[i];
                upper = colorStops[i+1];
                break;
            }
        }

        // Calcul du paramètre local entre lower et upper
        const range = upper.t - lower.t;
        const tLocal = (t - lower.t) / range;

        const r = Math.round(lower.color[0] + (upper.color[0] - lower.color[0]) * tLocal);
        const g = Math.round(lower.color[1] + (upper.color[1] - lower.color[1]) * tLocal);
        const b = Math.round(lower.color[2] + (upper.color[2] - lower.color[2]) * tLocal);

        return `rgb(${r}, ${g}, ${b})`;
    }

    public rotateData(data: number[][], rotation): number[][] {
        switch (rotation % 360) {
            case 90:
                return this.rotateData90(data);
            case 180:
                return this.rotateData180(data);
            case 270:
                return this.rotateData270(data);
            default:
                console.warn('Not a supported data rotation :', rotation);
                return data;
        }
    }

    private rotateData180(data: number[][]): number[][] {
        return data.map(row => row.slice().reverse()).reverse();
    }

    private rotateData90(data: number[][]): number[][] {
        const numRows = data.length;
        const numCols = data[0].length;
        const rotated: number[][] = [];

        for (let col = 0; col < numCols; col++) {
            const newRow: number[] = [];
            for (let row = numRows - 1; row >= 0; row--) {
                newRow.push(data[row][col]);
            }
            rotated.push(newRow);
        }

        return rotated;
    }

    private rotateData270(data: number[][]): number[][] {
        const numRows = data.length;
        const numCols = data[0].length;
        const rotated: number[][] = [];

        for (let col = numCols - 1; col >= 0; col--) {
            const newRow: number[] = [];
            for (let row = 0; row < numRows; row++) {
                newRow.push(data[row][col]);
            }
            rotated.push(newRow);
        }

        return rotated;
    }
}

export class PressureLocation  {
    top: number;
    bottom: number;
    topLeft: number;
    topRight: number;
    bottomLeft: number;
    bottomRight: number;
}

export class PressureGravityCenter  {
    x: number;
    y: number;
}